export default __webpack_public_path__ + "static/two-way-sync-3b59becdd86bce60e72401898f02d18f.svg";